import { render, staticRenderFns } from "./DetailVip.vue?vue&type=template&id=2167d756&scoped=true&"
import script from "./DetailVip.vue?vue&type=script&lang=js&"
export * from "./DetailVip.vue?vue&type=script&lang=js&"
import style0 from "./DetailVip.vue?vue&type=style&index=0&id=2167d756&prod&lang=css&"
import style1 from "./DetailVip.vue?vue&type=style&index=1&id=2167d756&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2167d756",
  null
  
)

export default component.exports